import { message } from 'antd';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { fetchCountriesAPI, fetchCountryStatesAPI } from '../../../services/address-service';
import { FETCH_COUNTRIES, FETCH_COUNTRIES_ERROR, FETCH_COUNTRIES_SUCCESS, FETCH_COUNTRY_STATES, FETCH_COUNTRY_STATES_ERROR, FETCH_COUNTRY_STATES_SUCCESS } from '../../actions/common/addressAction';
import _ from 'lodash';

export function* fetchCountries() {
    try {
        const response = yield call(fetchCountriesAPI);
        if (response.success) {
            yield put({ type: FETCH_COUNTRIES_SUCCESS, countries: response.data })

        } else {
            yield put({ type: FETCH_COUNTRIES_ERROR, error: response.error })
            message.error('Failed to fetch countries!');
        }
    } catch (error) {
        yield put({ type: FETCH_COUNTRIES_ERROR, error })
        message.error('Failed to fetch countries!');
    }
}


export function* fetchCountryStates({ payload }) {
    try {
        const response = yield call(fetchCountryStatesAPI, payload);
        if (response.success) {
            yield put({ type: FETCH_COUNTRY_STATES_SUCCESS, states: _.cloneDeep(response.data) })

        } else {
            yield put({ type: FETCH_COUNTRY_STATES_ERROR, error: response.error })
            message.error('Failed to fetch states!');
        }
    } catch (error) {
        yield put({ type: FETCH_COUNTRY_STATES_ERROR, error })
        message.error('Failed to fetch states!');
    }
}

function* addressWatcher() {
    yield takeLatest(FETCH_COUNTRIES, fetchCountries)
    yield takeLatest(FETCH_COUNTRY_STATES, fetchCountryStates)

}


export default function* rootSaga() {
    yield all([
        addressWatcher(),
    ]);
}